import React, { useEffect } from "react"
import PageWrapper from "Pages/@PageWrapper"
import { ADMIN_ROUTES } from "@constants"
import UserListTable from "Pages/Admin/Users/Table"
import MultipleUsersModal from "Pages/Admin/Users/MultipleModal"
import CreateUserDrawer from "Pages/Admin/Users/CreateDrawer"
import { offices } from "@signals"

export default function UsersControlAdminPage() {

	useEffect(() => {
		offices.value = []
	}, [])


	return <PageWrapper
		head={`DS Rentacar | ${ADMIN_ROUTES.TITLE}`}
		title={ADMIN_ROUTES.TITLE}
		subtitle={ADMIN_ROUTES.USER_CONFIG_SUBTITLE}
		isEmpty={false}
	>
		<UserListTable/>
		<MultipleUsersModal/>
		<CreateUserDrawer/>
	</PageWrapper>
}